<template>
  <div class="media">
    <div class="icon-main d-lg-block">
      <div class="icon-round">
        <svg width="25" height="25" fill="none">
          <use xlink:href="#mapPinWFill" />
        </svg>
      </div>
    </div>
    <div class="media-body">
      <cart-panel class="no-display"></cart-panel>
      <div
        class="timeline-card"
        v-if="order_type === CONST.ORDER_TYPE_TAKEAWAY"
      >
        <h6 class="hidden-xs-only">{{ _T(title) }}</h6>

        <div class="delivery-content saved-payment">
          <select-delivery-area-form ref="selectDAForm" />
        </div>
      </div>
      <div class="timeline-card" v-if="order_type === CONST.ORDER_TYPE_ONLINE">
        <div class="delivery-content saved-payment">
          <div v-if="guest_checkout">
            <h4 class="hidden-xs-only">
              {{ _T('Additional information') }}
            </h4>
          </div>
          <template v-else>
            <h4 class="hidden-xs-only">
              {{ _T('Delivery Address Confirmation') }}
            </h4>
            <h6 class="hidden-xs-only">{{ _T(title) }}</h6>
            <p
              class="text-danger"
              v-if="customer_addresses && !customer_addresses.length"
            >
              {{
                _T(
                  'No address found for current delivery area, please create one below.'
                )
              }}
            </p>
            <div class="radio-credit" v-if="customer_addresses">
              <form class="form-container">
                <template>
                  <label
                    v-for="(address, key) in customer_addresses"
                    :key="key"
                    class="d-block w-100 d-flex align-items-baseline"
                  >
                    <input
                      class="radio_animated"
                      :id="'edo-ani' + address.delivery_area_id + key"
                      type="radio"
                      name="edo-ani-address"
                      v-model="selectedAddress"
                      :value="address._id.$oid"
                    />
                    <customer-addresses
                      class="saved-details"
                      :address="address"
                      :filter-address="true"
                    />
                  </label>
                </template>
                <!-- <template v-for="(address, key) in customer_addresses">
                  <label
                    :key="'dis' + key"
                    class="disabled d-block w-100 d-flex align-items-baseline"
                    v-if="!addressInCurrentDa(address)"
                  >
                    <input
                      disabled="disabled"
                      class="radio_animated"
                      type="radio"
                      name="edo-ani-address"
                    />
                    <customer-addresses
                      class="saved-details"
                      :address="address"
                      :filter-address="true"
                    />
                  </label>
                </template> -->
              </form>
            </div>

            <div v-else>
              <h5>{{ _T('No Address selected') }}</h5>
            </div>
          </template>
          <div class="w57 grid-box mt-3">
            <a
              v-if="!guest_checkout"
              href="javascript:void(0)"
              data-toggle="modal"
              @click="
                $bvModal.show('add-address')
                return false
              "
            >
              +{{ _T('Create new Address') }}
            </a>
            <a
              href="javascript:void(0)"
              @click="$bvModal.show('add-address-instructions')"
            >
              +{{ _T('Extra instructions') }} ({{ _T('Optional') }})
            </a>
            <a
              href="javascript:void(0)"
              @click="$bvModal.show('add-order-note')"
            >
              +{{ _T('Order Note') }} ({{ _T('Optional') }})
            </a>
          </div>
        </div>
      </div>
    </div>
    <extra-instructions-popup />
    <add-order-note-popup />
    <customer-address />
  </div>
</template>
<script>
import ExtraInstructionsPopup from './AddAddressInstructions'
import CustomerAddress from '@/components/Modals/CustomerAddress'
import { mapGetters } from 'vuex'
import CustomerAddresses from '../Util/CustomerAddresses'
import AddOrderNotePopup from './AddOrderNote'
//import { eventBus } from '@/eventBus'
import CartPanel from '@/components/Blocks/Cart/MobileCart/CartPanel'
import selectDeliveryAreaForm from '@/components/SelectDeliveryAreaForm'
import * as CONST from '@/constants'
export default {
  name: 'DeliveryAddressConfirmation',
  data() {
    return {
      defaultAddress: '',
    }
  },
  components: {
    AddOrderNotePopup,
    CustomerAddresses,
    ExtraInstructionsPopup,
    CustomerAddress,
    CartPanel,
    selectDeliveryAreaForm,
  },
  computed: {
    // ...mapState({
    //   customerSelectedAddress: state => state.customer_store.selectedAddress,
    // }),
    title() {
      if (this.order_type === CONST.ORDER_TYPE_ONLINE) {
        return 'Deliver to'
      } else {
        return 'Receive from'
      }
    },
    selectedAddress: {
      get() {
        if (this.selectedDa && this.selectedDa._id) {
          if (this.selectedDa._id.$oid) {
            return this.selectedDa._id.$oid
          }
          return this.selectedDa._id
        }
        return undefined
      },
      set(val) {
        if (this.$route.params.store_id) {
          for (var addr of this.customer_address(this.$route.params.store_id)) {
            if (addr._id.$oid == val) {
              this.$store.commit('SET_CUSTOMER_SELECTED_ADDRESS', addr)
              this.$store.commit('SET_SELECTED_CHECKOUT_STORE', undefined)
            }
          }
        } else {
          this.customer_addresses.forEach(addr => {
            if (addr._id.$oid == val) {
              this.$store.commit('SET_CUSTOMER_SELECTED_ADDRESS', addr)
              this.$store.commit('SET_SELECTED_CHECKOUT_STORE', undefined)
            }
          })
        }
      },
    },
    ...mapGetters([
      '_T',
      'order_address_instructions',
      'deliveryAreaName',
      'customer_addresses_by_store_id',
      'brandStoreRoute',
      'guest_checkout',
      'make_slug_to_data',
      'order_note',
      'order_type',
      'selectedDa',
      'customer_addresses',
    ]),
  },
  methods: {
    // addressInCurrentDa(address) {
    //   debugger
    //   // get current DA by city, country by getter.locationCity, and selectedCountry
    //   // need to match city with getter.locationCity
    //   if (this.selectedDa) {
    //     // let city = this.locationCity
    //     // let country = this.selectedCountry
    //     return address.delivery_area_id === this.selectedDa.delivery_area
    //   } else {
    //     return false
    //   }
    // },
    customer_address(store_id) {
      let store = this.make_slug_to_data('store', store_id)
      if (!store) return this.customer_addresses_by_store_id(store_id)
      else return this.customer_addresses_by_store_id(store._id)
    },
    // customerAddressAddedListener(address_id) {
    //   debugger
    //   for (var addr of this.customer_addresses) {
    //     if (addr._id.$oid == address_id) {
    //       this.selectedAddress = addr._id.$oid
    //       return
    //     }
    //   }
    //   this.$store.dispatch('showNotification', {
    //     text: this._T(
    //       'Address have been added, but it is not served by selected store.'
    //     ),
    //     status: 'error',
    //   })
    // },
  },
  mounted() {
    // eventBus.$on('customerAddressAdded', this.customerAddressAddedListener)
    this.$nextTick(() => {
      if (this.$route.params.store_id) {
        for (var addr of this.customer_address(this.$route.params.store_id)) {
          if (
            !this.defaultAddress &&
            this.selectedDa &&
            addr.delivery_area_id === this.selectedDa.delivery_area
          ) {
            this.defaultAddress = addr
          }
        }
      } else {
        for (var cust_addr of this.customer_addresses) {
          if (
            !this.defaultAddress &&
            this.selectedDa &&
            cust_addr.delivery_area_id === this.selectedDa.delivery_area
          ) {
            this.defaultAddress = cust_addr
          }
        }
      }
      // this.$store.commit('SET_SELECTED_DA', da)
      this.$store.commit('SET_CUSTOMER_SELECTED_ADDRESS', this.defaultAddress)
    })
  },
  beforeDestroy() {
    // eventBus.$off('customerAddressAdded', this.customerAddressAddedListener)
  },
}
</script>
<style lang="scss" scoped>
label {
  cursor: pointer;
  &.disabled {
    opacity: 0.5;
    cursor: default;
  }
}
.body-rtl {
  .radio_animated {
    margin: 0 8px 0 10px;
  }
  .media-body {
    .timeline-card {
      text-align: right;
    }
  }
}
.form-container {
  padding-top: 3px;
}
.media-body {
  .no-display {
    display: block;
  }
  @media (max-width: 575px) {
    .no-display {
      display: none;
    }
    margin-top: $px8;
  }
  .vs__dropdown-toggle {
    display: grid;
    grid-template-columns: 1fr auto;
  }
}
.saved-details {
  /deep/ div {
    font-size: 14px;
    @media (max-width: 575px) {
      font-size: 12px;
    }
  }
}

.delivery-content {
  h5 {
    width: 100% !important;
  }

  label {
    margin-left: 0 !important;
  }

  div {
    &.w57 {
      width: 70% !important;
      display: grid;
      @media (max-width: 575px) {
        width: 100% !important;
        display: grid;
        a {
          padding-bottom: $px2;
        }
      }
    }
  }

  .radio-credit {
    overflow: hidden;
    max-height: $px350;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    input {
      left: $px2;
    }
  }
}
</style>
